import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.858 9.524A4 4 0 1 0 12 8v1.333a2.667 2.667 0 1 1-2.19 1.144l.857.856V8.667H8l.858.857Z" }));
export default createSvgIcon(iconPath, "Expired");
//# sourceMappingURL=StatusExpiredIcon.js.map